import { Button, ButtonProps } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface CopyAsNewButtonProps extends ButtonProps {
  productId: string;
  footprintId: string;
  calculationId: string;
}

const CopyAsNewButton = (props: CopyAsNewButtonProps): JSX.Element => {
  const navigate = useNavigate();
  const { productId, footprintId, calculationId, ...restProps } = props;
  const { t } = useTranslation();

  const onClick = () => {
    const href = `/products/${productId}/pcf/footprint/${footprintId}/calculations/${calculationId}/copy`;
    navigate(href);
  };

  return (
    <Button
      label={t('calculationsPage.calculationTableColumns.copyAsNewButton')}
      text
      onClick={onClick}
      {...restProps}
    />
  );
};

export default CopyAsNewButton;
